import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}'
*/
const DeleteSupplierOrderItemController = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteSupplierOrderItemController.url(args, options),
    method: 'delete',
})

DeleteSupplierOrderItemController.definition = {
    methods: ["delete"],
    url: '/api/supplier-order-item/{supplier_order_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}'
*/
DeleteSupplierOrderItemController.url = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order_item: typeof args.supplier_order_item === 'object'
        ? args.supplier_order_item.id
        : args.supplier_order_item,
    }

    return DeleteSupplierOrderItemController.definition.url
            .replace('{supplier_order_item}', parsedArgs.supplier_order_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}'
*/
DeleteSupplierOrderItemController.delete = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteSupplierOrderItemController.url(args, options),
    method: 'delete',
})

export default DeleteSupplierOrderItemController